export default "__VITE_ASSET__BON3ebjp__"